import {
  N_CampaignTemplateListViewItem,
  activeArchivedTabs,
  templateStatus,
} from "@specsheet-common/shared-types";

export const archivedCampaignTemplateTabIndex =
  activeArchivedTabs.indexOf("Archived");

export const isArchivedCampaignTemplateTab = (tabIndex: number): boolean =>
  tabIndex === archivedCampaignTemplateTabIndex;

export const isActiveCampaignTemplate = (
  template: N_CampaignTemplateListViewItem
): boolean => template.status === templateStatus.Active && template.isActive;

export const isSelectableCampaignTemplate = (
  template: N_CampaignTemplateListViewItem
): boolean => !template.isSystem;

export const isDeletableCampaignTemplate = (
  template: N_CampaignTemplateListViewItem
): boolean =>
  isSelectableCampaignTemplate(template) && isActiveCampaignTemplate(template);

export const isRestorableCampaignTemplate = (
  template: N_CampaignTemplateListViewItem
): boolean =>
  isSelectableCampaignTemplate(template) && !isActiveCampaignTemplate(template);

export const sortCampaignTemplateListItems = (
  templates: N_CampaignTemplateListViewItem[]
): N_CampaignTemplateListViewItem[] =>
  [...templates].sort((left, right) => {
    if (left.isSystem && !right.isSystem) {
      return -1;
    }
    if (!left.isSystem && right.isSystem) {
      return 1;
    }
    return left.label.localeCompare(right.label);
  });

export const filterCampaignTemplatesByActiveArchivedTab = (
  templates: N_CampaignTemplateListViewItem[],
  currentTab: number
): N_CampaignTemplateListViewItem[] =>
  templates.filter((template) =>
    currentTab === 0
      ? isActiveCampaignTemplate(template)
      : !isActiveCampaignTemplate(template)
  );

export const getActiveCampaignTemplates = (
  templates: N_CampaignTemplateListViewItem[]
): N_CampaignTemplateListViewItem[] =>
  sortCampaignTemplateListItems(
    templates.filter((template) => isActiveCampaignTemplate(template))
  );
